export default "__VITE_ASSET__CaI1Gpz5__"